import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import VerifyCode from './components/VerifyCode';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import ToastProvider from './components/ToastProvider';
import FleetDashboard from './components/FleetDashboard';
import AccountingDashboard from './components/AccountingDashboard';
import HomeRedirect from './components/HomeRedirect';
import { useAuth } from './contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const RequireAuth = ({ children }) => {
  const { loadingUser, token, isAuthenticated } = useAuth();
  if (loadingUser) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }
  if (!isAuthenticated || !token) {
    return <Navigate to="/login" replace />
  }

  return children;
};

/**
 * Gates children behind a whitelist of roles. Users whose role is not in
 * "allow" are sent to their own landing page via HomeRedirect, so a viewer
 * who types /accounting into the address bar lands on the fleet dashboard
 * rather than seeing a bare 403.
 */
const RequireRole = ({ allow, children }) => {
  const { role } = useAuth();
  if (!allow.includes(role)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const App = () => {
  return (
    <>
      <ToastProvider />
      <Router>
        <Routes>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/fleet-dashboard"
            element={
              <RequireAuth>
                <RequireRole allow={['admin', 'viewer']}>
                  <FleetDashboard />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/accounting"
            element={
              <RequireAuth>
                <RequireRole allow={['accounting']}>
                  <AccountingDashboard />
                </RequireRole>
              </RequireAuth>
            }
          />
        </Routes>
      </Router>
    </>
  );
};

export default App;
